module.exports = __webpack_public_path__ + "img/pts.514defbc.svg";